import { gql } from "apollo-boost";

// // query with getUserProducts
// export const HOME_QUERY = gql`
//   query Home {
//     simpleUser {
//       first_name
//       last_name
//       referral_code
//       type
//     }
//     getUserProducts {
//       productId
//       status
//     }
//   }`
// ;

// // query without new resolver - rely on roles
export const HOME_QUERY = gql`
  query Home {
    simpleUser {
      first_name
      last_name
      referral_code
      type
    }
  }`
;